import React, { useState } from 'react';
import { components } from '../components';
import { hooks } from '../hooks';
import { getItemFromLocalStorage } from '../utils/getItemFromLocalStorage';

export const AboutSection: React.FC = () => {
  const dispatch = hooks.useDispatch();
  const [opacity, setOpacity] = useState<number>(0);

  // Scroll and theme hooks
  hooks.useScrollToTop();
  hooks.useOpacity(setOpacity);
  hooks.useThemeColor('#F6F9F9', '#F6F9F9', dispatch);

  // Get configuration from localStorage
  const MENU_CONFIG = getItemFromLocalStorage("menuConfiguration");
  // Destructure expected fields; adjust keys as needed
  const { logo, aboutUsContent, latitude, longitude, address } = MENU_CONFIG || {};

  // Share location using the Web Share API (or fallback to copying the URL)
  const handleShareLocation = async () => {
    const shareData = {
      title: 'Our Restaurant Location',
      text: 'Check out our location!',
      url: `https://www.google.com/maps?q=${latitude},${longitude}&output=embed`,
    };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch (err) {
        //console.error('Error sharing:', err);
      }
    } else {
    //   navigator.clipboard.writeText(shareData.url);
    //   alert('Location URL copied to clipboard');
    }
  };

  return (
    <div id="screen" style={{ opacity }} className="min-h-screen bg-gray-100">
      {/* Header */}
      <components.Header showGoBack={true} title="About the Restaurant" />
      
      <main className="container mx-auto px-4 py-6">
        <section className="bg-white rounded-lg shadow-md p-6 mt-6">
          {/* Smaller Logo */}
          {logo && (
            <div className="flex justify-center mb-4">
              <img
                src={logo}
                alt="Restaurant Logo"
                className="w-32 h-auto rounded-full" // Smaller logo with width 128px (w-32)
              />
            </div>
          )}
          {/* Restaurant Description */}
          <p className="text-center text-gray-600 mb-6">
            {aboutUsContent}
          </p>
          {/* Embedded Map without API Key */}
          {latitude && longitude && (
            <div className="mb-6">
              <iframe
                width="100%"
                height="300"
                frameBorder="0"
                style={{ border: 0, borderRadius: '8px' }}
                src={`https://www.google.com/maps?q=${latitude},${longitude}&output=embed`}
                allowFullScreen
                title="Restaurant Location"
              ></iframe>
              {address && (
                <p className="text-center text-gray-500 mt-2">
                  {address}
                </p>
              )}
            </div>
          )}
          {/* Share Location Button */}
          <div className="flex justify-center">
            <button
              onClick={handleShareLocation}
              className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-md font-semibold transition"
            >
              Share Our Location
            </button>
          </div>
        </section>
      </main>
    </div>
  );
};
